export const toTitleCase = (str = "") =>
  str.replace(/./, (m) => m.toUpperCase());

export const getPaymentMethodsString = (
  acceptedPayments: Record<string, boolean>,
  paymentMethods: string[] = []
) => {
  // hardcoding options to ensure consistent display order
  const defaultPickupPayment = ["cash", "credit", "debit"].filter(
    (method) => acceptedPayments[method]
  );

  if (!paymentMethods || !paymentMethods.length) {
    paymentMethods = defaultPickupPayment.length
      ? defaultPickupPayment
      : ["cash"];
  }
  const appendCardStr = (m = "") =>
    toTitleCase(/credit/i.test(m) ? m + " Card" : m);
  const str = paymentMethods.map(appendCardStr).join(", ");
  return str;
};
